// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CareerBlock_container__ii4sm {
  padding: 40px 0;
}
.CareerBlock_container__ii4sm .CareerBlock_wrapperBlock__zaXTR {
  padding-top: 20px;
}
.CareerBlock_container__ii4sm .CareerBlock_wrapperBlock__zaXTR .CareerBlock_title__YL1vv {
  font-size: 26px;
  font-weight: bold;
  color: #fff;
}
.CareerBlock_container__ii4sm .CareerBlock_wrapperBlock__zaXTR .CareerBlock_gridBlock__SibP2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 50px;
  grid-row-gap: 25px;
}
.CareerBlock_container__ii4sm .CareerBlock_wrapperBlock__zaXTR .CareerBlock_gridBlock__SibP2 .CareerBlock_careerBlock__hICL4 {
  padding: 20px 40px;
  background: #fff;
  border-radius: 25px;
}
.CareerBlock_container__ii4sm .CareerBlock_wrapperBlock__zaXTR .CareerBlock_gridBlock__SibP2 .CareerBlock_careerBlock__hICL4 .CareerBlock_jobTitle__R9WU7 {
  margin-bottom: 5px;
  font-size: 20px;
  font-weight: 500;
}
.CareerBlock_container__ii4sm .CareerBlock_wrapperBlock__zaXTR .CareerBlock_gridBlock__SibP2 .CareerBlock_careerBlock__hICL4 .CareerBlock_expBlock__z9CSp p {
  margin-left: 5px;
}
.CareerBlock_container__ii4sm .CareerBlock_wrapperBlock__zaXTR .CareerBlock_gridBlock__SibP2 .CareerBlock_careerBlock__hICL4 a {
  text-decoration: underline;
  font-weight: bold;
  color: #d71921;
}

@media (max-width: 991px) {
  .CareerBlock_container__ii4sm {
    padding: 20px 0;
  }
  .CareerBlock_container__ii4sm .CareerBlock_wrapperBlock__zaXTR .CareerBlock_gridBlock__SibP2 {
    grid-template-columns: repeat(1, 1fr);
  }
  .CareerBlock_container__ii4sm .CareerBlock_wrapperBlock__zaXTR .CareerBlock_gridBlock__SibP2 .CareerBlock_careerBlock__hICL4 {
    font-size: 14px;
  }
}
@media (max-width: 768px) {
  .CareerBlock_container__ii4sm .CareerBlock_wrapperBlock__zaXTR .CareerBlock_title__YL1vv {
    font-size: 18px;
  }
  .CareerBlock_container__ii4sm .CareerBlock_wrapperBlock__zaXTR .CareerBlock_gridBlock__SibP2 .CareerBlock_careerBlock__hICL4 {
    padding: 10px 20px;
  }
  .CareerBlock_container__ii4sm .CareerBlock_wrapperBlock__zaXTR .CareerBlock_gridBlock__SibP2 .CareerBlock_careerBlock__hICL4 .CareerBlock_jobTitle__R9WU7 {
    font-size: 16px;
  }
  .CareerBlock_container__ii4sm .CareerBlock_wrapperBlock__zaXTR .CareerBlock_gridBlock__SibP2 .CareerBlock_careerBlock__hICL4 .CareerBlock_expBlock__z9CSp p {
    font-size: 14px;
  }
  .CareerBlock_container__ii4sm .CareerBlock_wrapperBlock__zaXTR .CareerBlock_gridBlock__SibP2 .CareerBlock_careerBlock__hICL4 a {
    font-size: 14px;
  }
  .CareerBlock_container__ii4sm .CareerBlock_wrapperBlock__zaXTR .CareerBlock_gridBlock__SibP2 .CareerBlock_careerBlock__hICL4 img {
    width: 65px;
  }
}
@media (max-width: 575px) {
  .CareerBlock_container__ii4sm {
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CareerBlock/CareerBlock.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,iBAAA;AACJ;AACI;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AACN;AAEI;EACE,aAAA;EACA,qCAAA;EACA,qBAAA;EACA,kBAAA;AAAN;AAEM;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AAAR;AAEQ;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAAV;AAIU;EACE,gBAAA;AAFZ;AAMQ;EACE,0BAAA;EACA,iBAAA;EACA,cAAA;AAJV;;AAWA;EACE;IACE,eAAA;EARF;EAWI;IACE,qCAAA;EATN;EAWM;IACE,eAAA;EATR;AACF;AAeA;EAGM;IACE,eAAA;EAfN;EAmBM;IACE,kBAAA;EAjBR;EAmBQ;IACE,eAAA;EAjBV;EAqBU;IACE,eAAA;EAnBZ;EAuBQ;IACE,eAAA;EArBV;EAwBQ;IACE,WAAA;EAtBV;AACF;AA6BA;EACE;IACE,aAAA;EA3BF;AACF","sourcesContent":[".container {\n  padding: 40px 0;\n\n  .wrapperBlock {\n    padding-top: 20px;\n\n    .title {\n      font-size: 26px;\n      font-weight: bold;\n      color: #fff;\n    }\n\n    .gridBlock {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      grid-column-gap: 50px;\n      grid-row-gap: 25px;\n\n      .careerBlock {\n        padding: 20px 40px;\n        background: #fff;\n        border-radius: 25px;\n\n        .jobTitle {\n          margin-bottom: 5px;\n          font-size: 20px;\n          font-weight: 500;\n        }\n\n        .expBlock {\n          p {\n            margin-left: 5px;\n          }\n        }\n\n        a {\n          text-decoration: underline;\n          font-weight: bold;\n          color: #d71921;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 991px) {\n  .container {\n    padding: 20px 0;\n\n    .wrapperBlock {\n      .gridBlock {\n        grid-template-columns: repeat(1, 1fr);\n\n        .careerBlock {\n          font-size: 14px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .container {\n    .wrapperBlock {\n      .title {\n        font-size: 18px;\n      }\n\n      .gridBlock {\n        .careerBlock {\n          padding: 10px 20px;\n\n          .jobTitle {\n            font-size: 16px;\n          }\n\n          .expBlock {\n            p {\n              font-size: 14px;\n            }\n          }\n\n          a {\n            font-size: 14px;\n          }\n\n          img {\n            width: 65px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 575px) {\n  .container {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CareerBlock_container__ii4sm`,
	"wrapperBlock": `CareerBlock_wrapperBlock__zaXTR`,
	"title": `CareerBlock_title__YL1vv`,
	"gridBlock": `CareerBlock_gridBlock__SibP2`,
	"careerBlock": `CareerBlock_careerBlock__hICL4`,
	"jobTitle": `CareerBlock_jobTitle__R9WU7`,
	"expBlock": `CareerBlock_expBlock__z9CSp`
};
export default ___CSS_LOADER_EXPORT___;
